var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"percentage"},[_c('vue-numeric',{attrs:{"precision":_vm.custom,"separator":".","read-only":true,"value":_vm.value}}),_vm._v(" %\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }